import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { PwaUpdateService } from '../../services/pwa-update.service';

@Component({
  selector: 'app-pwa-update-prompt',
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslocoPipe],
  templateUrl: './pwa-update-prompt.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PwaUpdatePromptComponent {
  readonly pwaUpdate = inject(PwaUpdateService);

  async update(): Promise<void> {
    await this.pwaUpdate.activateUpdate();
  }

  dismiss(): void {
    this.pwaUpdate.dismissUpdate();
  }
}
